import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Package, KeyRound, Route } from "lucide-react";
import { LogoVertical } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/format";

export default function Landing() {
  const { session, profile } = useAuth();
  const cta = session && profile ? roleHome(profile.role) : "/auth";

  return (
    <div className="relative flex min-h-screen flex-col items-center bg-[#0B0B0B] px-5 text-white">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(1000px 520px at 50% 32%, rgba(255,106,0,0.14), transparent 62%), radial-gradient(700px 340px at 50% 92%, rgba(255,106,0,0.07), transparent 60%)",
        }}
      />

      <motion.main
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative flex w-full max-w-lg grow flex-col items-center justify-center py-16 text-center"
      >
        <LogoVertical className="w-full max-w-xs sm:max-w-sm" />

        <p className="mt-6 font-heading text-xs font-extrabold uppercase tracking-[0.3em] text-transparent sm:text-sm"
           style={{ backgroundImage: "linear-gradient(90deg,#FF6A00,#FFC400)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>
          Llevamos lo que necesitas
        </p>

        <h1 className="mt-8 max-w-xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl" data-testid="landing-headline">
          Tus envíos, en movimiento.
        </h1>

        <p className="mt-5 max-w-md text-sm leading-relaxed text-gray-400 sm:text-base" data-testid="landing-sub">
          Conectamos negocios con conductores disponibles para transportar productos, paquetes y
          mercancías. Solicita tu envío, consulta su estado y confirma la entrega de forma sencilla
          y segura.
        </p>

        <div className="mt-9 flex w-full max-w-xs flex-col gap-3 sm:max-w-sm sm:flex-row">
          <Link
            to={cta}
            data-testid="landing-cta-primary"
            className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-[#FF6A00] px-6 py-3.5 font-extrabold text-black transition-transform active:scale-95"
          >
            Ingresar <ArrowRight size={18} />
          </Link>
          <Link
            to="/auth?mode=register"
            data-testid="landing-cta-register"
            className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-[#27272A] bg-[#141416] px-6 py-3.5 font-semibold text-white transition-colors hover:bg-[#1e1e21]"
          >
            Crear cuenta
          </Link>
        </div>

        <p className="mt-5 text-xs text-gray-500" data-testid="landing-register-hint">
          ¿Primera vez en RAPIFAST?{" "}
          <Link to="/auth?mode=register" data-testid="landing-register-link" className="font-semibold text-[#FF6A00] transition-colors hover:text-amber-400">
            Crea tu cuenta.
          </Link>
        </p>

        <div className="mt-10 grid grid-cols-3 gap-2 border-t border-[#1e1e21] pt-6 text-xs text-gray-500 sm:gap-6">
          <div className="flex items-center gap-1.5">
            <Package size={13} className="text-[#FF6A00]" /> Carga, no personas
          </div>
          <div className="flex items-center gap-1.5">
            <Route size={13} className="text-[#FF6A00]" /> Estados en vivo
          </div>
          <div className="flex items-center gap-1.5">
            <KeyRound size={13} className="text-[#FF6A00]" /> Entrega con código
          </div>
        </div>
      </motion.main>

      <footer className="relative w-full border-t border-[#18181B] px-5 py-5 text-center text-xs text-gray-600">
        © {new Date().getFullYear()} RAPIFAST · LLEVAMOS LO QUE NECESITAS · Un producto de Transformart
      </footer>
    </div>
  );
}
